/**
 * @file dispatchAnswerInput.ts
 * Exports a method to add a submitted answer to the answers within AppState.
 */
import { prop, pick, map } from 'ramda';
import { getQuestions } from '.';
import type { AppState } from '../types';
import { actionProps } from './dispatchAnswerSingle';

/**
 * Helper method that returns a transformer function for updating answer data especially for text input field.
 *
 * This method updates the answers property within AppState and returns the
 * values to the reducer. This method is for updating questions that allow a
 * single value. Previously submitted values will be removed on update.
 *
 * @param {AppState} appState
 *   The application state before applying actions.
 * @param {Object} action
 *   Dispatch action object.
 *
 * @returns {Object}
 *   An updated object of answers data for AppState.
 */
export default (appState: AppState, action: actionProps) => {
  const submitted = prop('submitted')(appState);
  submitted['Q2'] = {
    [action.answerId]: action.answerValue,
  };

  // Get an array of all questionsIds for the current set of questions.
  // For questions that have conditional visibility, the list of valid questions
  // changes are more questions are answered. If the user navigates backwards,
  // they may change a answer the makes a downstream question invalid.
  const validQuestions = map(prop('id'), getQuestions(appState));

  // Only return answers to valid questions.
  return pick(validQuestions, submitted);
};
